import FieldDimensionId from '@core/constants/FieldDimension';
import { MaterialId } from '@core/constants/Material';
import { BorderShapeId } from '@core/constants/Shape';
import {
    IDimensionUnit,
    IFormFieldDimension,
    IFormFieldDimensionDefaultValueKey,
    IFormFieldMaterial,
    IFormFieldShape,
    IFormInputType,
} from '../../../interfaces/Form';
import { allLegs } from './shapesGroups';
import allMaterials, {
    allCeramics,
    allConcretes,
    allMarbleAndStones,
    allMetals,
    allSolidWoods,
    getMaterialsWithExceptions,
} from './materialGroups';

export const fieldsDeskTrayMaterial: IFormFieldMaterial = {
    material: {
        value   : undefined,
        options : getMaterialsWithExceptions(allMaterials,
            [
                MaterialId.BlackLocust,
                MaterialId.Iroko,
                MaterialId.Douglas,
                MaterialId.DouglasEngineered,
                MaterialId.DouglasRecycled,
                MaterialId.DouglasVeneer,
                MaterialId.Padouk,
                MaterialId.PadoukEngineered,
                MaterialId.PadoukRecycled,
                MaterialId.PadoukVeneer,
                MaterialId.Ipe,
                MaterialId.IpeRecycled,
                MaterialId.IpeEngineered,
                MaterialId.IpeVeneer,
                MaterialId.Garapa,
                MaterialId.Aluminum,
                MaterialId.Zinc,
                MaterialId.Brass,
                MaterialId.SheetMetal,
                MaterialId.PlexiglassFluorescent,
                MaterialId.PlexiglassFrosted,
                MaterialId.PlexiglassMirror,
                MaterialId.PlexiglassTransparent,
                MaterialId.PlexiglassWhite,
                MaterialId.PolycarbonateOpaque,
                MaterialId.PolycarbonateTeinted,
                MaterialId.PolycarbonateTransparent,
                MaterialId.Pvc,
                MaterialId.PvcRigid,
            ]),
        required: true,
    },
};

export const fieldsDeskBorder: IFormFieldShape = {
    value   : undefined,
    options : [
        BorderShapeId.SquareStraightEdge,
        BorderShapeId.LiveEdge,
        BorderShapeId.StraightEdgeChamfer,
        BorderShapeId.StraightEdgeSoftened,
        BorderShapeId.RoundedQuarterCircle,
        BorderShapeId.RoundedHalfCircle,
        BorderShapeId.AirplaneWings,
    ],
    required: true,
};

export const fieldsDeskLegs: IFormFieldShape = {
    value    : undefined,
    options  : allLegs,
    required : true,
};

export const fieldsDeskLegsMaterial: IFormFieldMaterial = {
    material: {
        value   : undefined,
        options : getMaterialsWithExceptions(
            [
                ...allMetals,
                ...allSolidWoods,
                ...allConcretes,
                ...allCeramics,
                ...allMarbleAndStones,
            ],
            [
                MaterialId.BlackLocust,
                MaterialId.Iroko,
                MaterialId.Douglas,
                MaterialId.Redcedar,
                MaterialId.Larch,
                MaterialId.Padouk,
                MaterialId.Ipe,
                MaterialId.Garapa,
                MaterialId.Zinc,
                MaterialId.Brass,
                MaterialId.SheetMetal,
            ],
        ),
        required: true,
    },
};

export const fieldsDeskLegsDimension: IFormFieldDimension = {
    [FieldDimensionId.Height]: {
        value         : undefined,
        type          : IFormInputType.Range,
        unit          : IDimensionUnit.Centimeters,
        step          : 50,
        range         : { min: 600, max: 900 },
        required      : true,
        defaultValue  : 750,
        defaultValues : [
            [IFormFieldDimensionDefaultValueKey.StandardHeight, 750],
        ],
    },
};

